<div class="dashboard-master-container">

    <div class="dashboard-header">
            
        <div class="header-container-master">
            <div class="header-container">
                <div id="header" class="header">
    
                    <div class="logo-prozess">
                        <a href=""><img class="imge" src="/assets/images/prozess-web-logo02.png" alt="Header Logo"></a>
                    </div>
                   
                    <div class="d-flex align-items-center justify-content-between">
                            
                        <div class="logo-entidad d-flex align-items-center ">
                            <img class="imge" [src]="logoEntidad$ | async" alt="LogoEntidad" />
                        </div>
    
                        <div class="user-options">
                            <nb-actions>
                                <nb-action id="test_1">
                                    <nb-user size="large" class="usuario" id="test_2" [nbContextMenu]="itemsUsuario"
                                        nbContextMenuTag="MenuUsuario" [name]="user || ''">
                                    </nb-user>
                                </nb-action>
                            </nb-actions>
    
                        </div>
                    </div>

                 
                </div>
            </div>
    
            
        </div>
    
    </div>

    
</div>

<nb-layout [withScroll]=false>

    <!-- <nb-layout-header class="header" fixed>
        <div id="przss-head">

            <div class="przss-logo">
                <a href=""><img class="imge" src="/assets/images/prozess-web-logo02.png" alt="Header Logo"></a>
            </div>

            <div class="logo-entidad">
                <img class="imge" [src]="logoEntidad$ | async" alt="LogoEntidad" />
            </div>
            
            <nb-actions>
                <nb-action id="test_1">
                    <nb-user size="large" class="usuario" id="test_2" [nbContextMenu]="itemsUsuario"
                        nbContextMenuTag="MenuUsuario" [name]="user || ''">
                    </nb-user>
                </nb-action>
            </nb-actions>
        </div>
    </nb-layout-header> -->


    <nb-sidebar id="sidebar" class="sideBar">
        <nb-sidebar-header>
            <div class="sidebar-header">
                <button mat-icon-button class="BtnColapsoMenu" (click)="fnCollapse('sidebar')">
                    <i class="fas fa-bars"></i>
                </button>
            </div>
        </nb-sidebar-header>
        <div *ngIf="menus$ | async as menus" class="menu">
            <app-menu *ngIf="collapse_side_bar_one" [bo_recargarMenu]="bo_recargarMenu" [bo_mostrarColapso]="collapse_side_bar_one" [itemsComollega]="menus"
                (RutaEnviar)="mostrarRuta=$event" (click)="fnCollapse('sidebar')">
            </app-menu>
            <app-menu *ngIf="!collapse_side_bar_one" [bo_recargarMenu]="bo_recargarMenu" [bo_mostrarColapso]="collapse_side_bar_one" [itemsComollega]="menus"
                (RutaEnviar)="mostrarRuta=$event" (click)="Expand()">
            </app-menu>
        </div>
    </nb-sidebar>

    <nb-layout-column class="main-content" id='main-content'>
        <nb-layout-header class="subheader" subheader>
            <div>
                <div class="d-flex align-items-center justify-content-center">
                  
                    <p class="ruta">{{mostrarRuta}}</p>
                </div>
            </div>
        </nb-layout-header> 
    
        <router-outlet></router-outlet>

    </nb-layout-column>
</nb-layout>

























